<template>
    
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="m-0" style="margin-bottom: 10px !important">Beranda Absensi</h3>
                    <p class="mb-0">Ini adalah fitur tambahan untuk melakukan pencatatan absensi karyawan ya gan :)</p>

                    <div class="row mt-4">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="card mt-0 card-stats">
                                <div class="box-horizontal mb-0">
                                    <div class="box-menu text-center pointer" @click="link.history()">
                                        <i class="material-icons d-block text-info">list</i>
                                        History Absen
                                    </div>
                                    <div class="box-menu text-center pointer" @click="link.karyawan()">
                                        <i class="material-icons d-block text-warning">people</i>
                                        Karyawan
                                    </div>
                                    <div class="box-menu text-center pointer" @click="link.pembayaranbyadmin()" v-show="false">
                                        <i class="material-icons d-block text-success">surfing</i>
                                        Pmbyran By Admin
                                    </div>
                                    <div class="box-menu text-center pointer" @click="link.rangkuman()" v-show="false">
                                        <i class="material-icons d-block text-warning">spa</i>
                                        Rangkuman Keuangan
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card mt-3">
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class=" text-info">
                                    <th width="50px">No</th>
                                    <th>Nama Karyawan</th>
                                    <th>Jabatan</th>
                                    <th>Jam Masuk</th>
                                    <th>Jam Pulang</th>
                                    <th>Tanggal</th>
                                    <th>Absen Dari</th>
                                    </thead>
                                    <!-- LOADING -->
                                    <tbody v-show="data.loading">
                                    <tr>
                                        <td colspan="8"><Loading></Loading></td>
                                    </tr>
                                    <tr>
                                        <td colspan="8"><Loading></Loading></td>
                                    </tr>
                                    <tr>
                                        <td colspan="8"><Loading></Loading></td>
                                    </tr>
                                    </tbody>
                                    <!-- DATA -->
                                    <tbody v-show="!data.loading">
                                    <tr v-for="(u, index) in theGet.data.List">
                                        <td>
                                        {{index+1}}
                                        </td>
                                        <td>
                                        {{ u.nama }}
                                        </td>
                                        <td>
                                            <span class="d-block">{{ u.jabatan }}</span>
                                        </td>
                                        <td>
                                        {{myGlobal.jamIndo(u.masuk)}}</br>
                                        <span class="text-warning" v-show="parseInt(u.telat) > 0">Telat {{u.telat}} Menit</span>
                                        </td>
                                        <td>
                                        {{myGlobal.jamIndo(u.pulang)}}
                                        </td>
                                        <td>
                                        {{myGlobal.tglIndo(u.tanggal)}}
                                        </td>
                                        <td>
                                        {{u.absen_di}}
                                        </td>
                                    </tr>
                                    <!-- NULL -->
                                    <tr v-if="theGet.data.List == null">
                                        <td></td>
                                        <td>Tidak ada Data </td>
                                    </tr>
                                    <!-- NULL -->
                                    <tr v-if="data.filterState == true">
                                        <td></td>
                                        <td><strong>Total Telat </strong></td>
                                        <td></td>
                                        <td>{{ data.totalTelat }} Menit</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
                
            </div>
        

            <!-- MODAL -->
            <div class="modal" tabindex="-1" role="dialog" v-show="data.modalCekSingkron">
                <div class="overlay"></div>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-body" style="max-height: 500px; overflow: auto">
                        <div v-show="data.loadingBox" class="text-center">
                            <h3 class="mb-0 text-info">Tunggu Sebentar...</h3>
                            <span>Sedang mencari data anda</span>
                        </div>
                        <div v-show="data.baru">
                            <h3 class="mb-0">Oops, tidak ada data</h3>
                            <span>Sepertinya Anda baru pertama kesini, buat akun untuk bisa menggunakan Akun ini </span>
                        </div>
                        <div v-show="!data.loadingBox" class="text-center">
                            <span>Akun Beatcom Network Anda :</span>
                            <h3 class="text-center text-info mt-1">{{data.namaQ}}</h3>
                            <button class="btn btn-info" @click="theGet.loginSubmit()">Gunakan akun ini</button>
                            <button class="btn btn-gray" @click="$router.go(-1)">Batalkan</button>
                        </div>
                        </div>
                    </div>
                </div>
            
            </div>

        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/InterfaceAbsensi' 
import router from '@/router'
import Loading from '@/globalFunc/Loading' 

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 
    "Loading" : Loading

  }, 
  setup() {
    const data = reactive({
        
      // ABSENSI MODAL
      namaQ: null,
      namaAbsensi: null,
      modalCekSingkron: true,
      loadingBox: true,
      loading: true,
      baru: false
    })

    const theGet = {
        data: reactive({
          List: [],
        }),
        
        datae() {
            data.loading = true;
            setTimeout(function() {
                theGet.dataeNow();
            }, 1000);
        },
        dataeNow() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi')
            };

            //console.log(JSON.stringify(datax))
        
            var apiUrl = inter.historyAbsen();
            myGlobal.callAbsensi(datax,apiUrl).then(x => {
            
                // myGlobal.loger(x);

                data.loading = false;

                if (x.status == true) {
                    theGet.data.List = x.data;
                    theGet.data.Total = x.pesan.masuk;

                    if(data.filterState == true) {

                        let datae = theGet.data.List;
                        
                        let totalTelatT = 0;
                        for(var i = 0; i < datae.length; i++) {
                            totalTelatT = totalTelatT + parseInt(datae[i]["telat"])
                        }

                        data.totalTelat = totalTelatT
                        
                    }
                    
                    var datax = x.data;

                } else {
                    theGet.data.List = null;
                }
            })
        },
        
        login() {
            data.loading = true;
            setTimeout(function() {
                theGet.loginNow();
            }, 500);
        },
        loginNow() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken')
            };
        
            var apiUrl = inter.login();
            myGlobal.callAbsensi(datax,apiUrl).then(x => {
            
                //myGlobal.loger(x);

                if (!x.status == true) {

                    data.baru = true;
                
                } else {

                    //theGet.data.List = null;

                    theGet.loginSubmit();
                }
                
                // data.loadingBox = false;

                // data.loading = false;

                /*

                */
            })
        },
        loginSubmit() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken'),
                nama: sessionStorage.getItem('admin')
            };
        
            var apiUrl = inter.loginSubmit();
            myGlobal.callAbsensi(datax,apiUrl).then(x => {
                //myGlobal.loger(x);

                if (x.status == true) {
                    //data.baru = true;
                    sessionStorage.setItem('myTokenAbsensi', x.data);

                    data.modalCekSingkron = false;

                    //theGet.dataeNow();

                    theGet.datae();
                
                } else {
                    //theGet.data.List = null;
                    alert(x.pesan)
                }
                
            })
        },
    }
    const link = {
        history() {
            router.push({ 
                name: 'absensi-history'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },

        karyawan() {
            router.push({ 
                name: 'absensi-karyawan'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        pembayaranbyadmin() {
            router.push({ 
                name: 'history-pembayaran'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        rangkuman() {
            router.push({ 
                name: 'pembukuan-rangkuman'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        detail(kategori) {
            let isCustom = myGlobal.isCustom();
            if (isCustom == null) {
                alert("hehe, maap gan. fitur detail cuma untuk custom ya")
                return false;
            }
            // LANJOT CUSTOM TERNYATA

            router.push({ 
                name: 'pembukuan-pengeluaran',
                params: {
                    kategori: kategori
                } 
            });
        },
    }

    return {
      data, 
      theGet,
      myGlobal,
      link
    }
  },
  mounted () {
    document.title = "Pembukuan";

    this.data.namaQ = sessionStorage.getItem('admin');
    
    let TokenAbsensi = sessionStorage.getItem("myTokenAbsensi");
    if(TokenAbsensi == null) {
      this.theGet.login();
    } else {
      this.data.modalCekSingkron = false;
      

      this.theGet.datae();
    }
  }
}

/**
 * DETAIL TIAP KATEGORI
 * DETAIL CUSTOM ONLY
 * LINK KAN MENU LAIN LAIN
 */

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.box-menu {
    padding: 15px;
}
.box-menu > i {
    font-size: 35pt;
}
.modal {
	display: inherit;
}
.overlay {
	position:fixed;
	top:0;bottom:0;right:0;left:0;
	background-color: rgba(0,0,0,0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/absensi/beranda/main.vue